import { CheckCircle2, Clock, ShieldCheck, Users, Zap, HeadphonesIcon } from "lucide-react";

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: CheckCircle2,
      title: "Transparent Process",
      description: "Clear communication at every step with no hidden charges. You know exactly what to expect throughout the registration process."
    },
    {
      icon: Zap,
      title: "Fast & Accurate Documentation",
      description: "Swift processing without compromising accuracy. Our streamlined systems ensure quick turnaround times for all services."
    },
    {
      icon: ShieldCheck,
      title: "100% Legal Compliance",
      description: "All documentation meets regulatory standards. We ensure complete compliance with government norms and legal requirements."
    },
    {
      icon: Users,
      title: "Experienced Professionals",
      description: "Over 20 years of expertise in property registration. Our team brings decades of combined experience to serve you better."
    },
    {
      icon: HeadphonesIcon,
      title: "End-to-End Support",
      description: "From consultation to final registration, we guide you through every step. Complete handholding throughout the process."
    },
    {
      icon: Clock,
      title: "Time-Efficient Service",
      description: "We value your time and ensure minimal delays. Efficient coordination with sub-registrar offices for hassle-free registration."
    }
  ];

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-emerald-50/50 to-transparent"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-amber-50 rounded-full px-6 py-2 mb-6">
            <span className="text-amber-700 font-semibold text-sm tracking-wide">WHY CHOOSE US</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Your Trusted Partner for Property Registration
          </h2>
          
          <p className="text-lg text-slate-600">
            With two decades of excellence, we've built our reputation on trust, accuracy, and client satisfaction.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-white to-slate-50 rounded-xl p-8 border border-slate-200 hover:border-emerald-300 hover:shadow-xl transition-all duration-300"
            >
              <div className="bg-emerald-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 group-hover:bg-emerald-600 transition-colors">
                <reason.icon className="text-emerald-700 group-hover:text-white transition-colors" size={28} />
              </div>
              
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {reason.title}
              </h3>
              
              <p className="text-slate-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        {/* Image section */}
        <div className="bg-gradient-to-r from-slate-800 to-emerald-800 rounded-2xl overflow-hidden shadow-2xl">
          <div className="grid lg:grid-cols-2 gap-0">
            <div className="p-12 flex flex-col justify-center">
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Ready to Register Your Property?
              </h3>
              <p className="text-gray-200 text-lg mb-8 leading-relaxed">
                Get started with India's most trusted property registration service. Our experts are ready to assist you with personalized consultation and support.
              </p>
              <div className="flex flex-wrap gap-4">
                <a 
                  href="tel:+918217026707"
                  className="bg-white text-slate-800 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl"
                >
                  Call: +91 82170 26707
                </a>
                <a 
                  href="tel:+917411026699"
                  className="bg-emerald-600 text-white px-8 py-4 rounded-lg font-bold hover:bg-emerald-700 transition-all duration-300 shadow-lg hover:shadow-xl"
                >
                  Call: +91 74110 26699
                </a>
              </div>
            </div>
            <div className="hidden lg:block">
              <img 
                src="https://images.unsplash.com/photo-1672380135241-c024f7fbfa13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGhhbmRzaGFrZXxlbnwwfHx8fDE3NzIzOTIwOTR8MA&ixlib=rb-4.1.0&q=85" 
                alt="Professional consultation"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
